@file:Suppress("UNCHECKED_CAST_TO_EXTERNAL_INTERFACE")

package org.example.project.screens_cus

import androidx.compose.runtime.*
import kotlinx.coroutines.launch
import org.example.project.enginetabular.allFromTabularCommit
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.InfrastrukturApi
import org.example.project.utils.All

@Composable
fun CUSPalettenTypverwaltung(art: String = org.example.project.service.currentSaveArt()) {
    var modulTypen by remember { mutableStateOf<List<All>>(emptyList()) }
    val scope = rememberCoroutineScope()
    LaunchedEffect(art) {
        val loaded = InfrastrukturApi.loadModulTypen()
        if (loaded.isEmpty()) {
            val defaults = listOf(
                All(id = "1", modulTyp = "CCg1", bezeichnung = "CCg1 Platz", vpCCG1 = "1", vpCCG2 = "0"),
                All(id = "2", modulTyp = "CCg2", bezeichnung = "CCg2 Platz", vpCCG1 = "2", vpCCG2 = "0")
            )
            defaults.forEach { InfrastrukturApi.saveModulTyp(it) }
            modulTypen = defaults
        } else {
            modulTypen = loaded.sortedBy { it.id.toIntOrNull() ?: 0 }
        }
    }

    val headers = listOf(
        "ID", "Modultyp", "Bezeichnung", "Kapazität CCg1", "Kapazität CCg2"
    )

    val saveFields = listOf("id", "modulTyp", "bezeichnung", "vpCCG1", "vpCCG2")

    TabularScreen(
        screenKey = "PalettenTypVerwaltung",
        rollenKey = "PalettenTypVerwaltung",
        title = "Modultyp-Verwaltung",
        headers = headers,
        models = modulTypen,
        data = modulTypen.map { m ->
            m.id to listOf(
                m.id, m.modulTyp, m.bezeichnung, m.vpCCG1, m.vpCCG2
            )
        },
        editable = true,
        includeMetadata = true,
        nonEditableCols = setOf("ID"),
        createRow = { _ ->
            val nextId = ((modulTypen.maxOfOrNull { it.id.toIntOrNull() ?: 0 } ?: 0) + 1).toString()
            listOf(nextId, "", "", "", "")
        },
        onCommit = { rows ->
            scope.launch {
                rows.forEach { (id, cols) ->
                    val existing = modulTypen.firstOrNull { it.id == id }
                    val neu = allFromTabularCommit(id, cols, saveFields)
                    // Kapazitäts-Validierung beibehalten
                    val c1 = neu.vpCCG1.toIntOrNull() ?: 0
                    val c2 = neu.vpCCG2.toIntOrNull() ?: 0
                    val valid = when (neu.modulTyp) {
                        "CCg1" -> (c1 == 1 && c2 == 0) || (c1 == 0 && c2 == 0)
                        "CCg2" -> (c1 == 2 && c2 == 0) || (c1 == 0 && c2 == 1)
                        else -> true
                    }
                    val changed = existing == null || existing != neu
                    if (valid && changed) {
                        InfrastrukturApi.saveModulTyp(neu)
                    }
                }
            }
        },
        onDeleteRows = { ids -> ids.forEach { id -> InfrastrukturApi.deleteModulTyp(id) } }
    )
}
